import { DateTime } from 'luxon';
import { CoreItem, CoreItemBackend } from '../core-item/core-item';
import { UserClerkPublicMetadata } from '../user/user-clerk';

export const SESSION_LENGTH = 63; // 60 mins + 3 mins buffer

export const INIT_CREDITS = 20;
export const FREE_TRIAL_MINS = 13;

export const FREE_TRIAL_INTERVAL_HOURS = 24;

export enum InterviewCredits {
  normal = 10,
  code = 15,
}

export function isCreditsEnoughForInterviewType(interviewType: InterviewType, credits: number) {
  if (interviewType === InterviewType.normal) {
    return credits >= InterviewCredits.normal;
  } else if (interviewType === InterviewType.code) {
    return credits >= InterviewCredits.code;
  } else {
    throw new Error('Unknown interview type');
  }
}

export function canFreeTrial(userPublicMetadata: UserClerkPublicMetadata) {
  const oldFreeTrialDate = userPublicMetadata.freeTrialDateStr
    ? DateTime.fromISO(userPublicMetadata.freeTrialDateStr as string)
    : undefined;

  if (!oldFreeTrialDate) {
    return true;
  }

  if (oldFreeTrialDate && -oldFreeTrialDate.diffNow('hours').hours > FREE_TRIAL_INTERVAL_HOURS) {
    return true;
  }

  return false;
}

export interface InterviewBackend extends CoreItemBackend {
  type: InterviewType;
  status: InterviewStatus;
  subData: InterviewSubData;
}

export enum InterviewStatus {
  notStarted = 'notStarted',
  ongoing = 'ongoing',
  done = 'done',
}

export enum InterviewType {
  normal = 'normal',
  code = 'code',
}

export interface Interview extends CoreItem {
  subData: InterviewSubData;
}

export interface InterviewSubData {
  interviewRound: string;
  goalId: string;
  goalCompany: string;
  goalPosition: string;
  resumeId: string;
  resumeTitle: string;
  language: string;
  programmingLanguage?: string;
  performance: InterviewPerformance;
  creativity: InterviewCreativity;
  answerMode: InterviewAnswerMode;
  additionalDetails?: string;
  deepgramKey?: string;
  deepgramKeyExpiredAtStr?: string;
}

export enum InterviewPerformance {
  Speed = 'Speed',
  Quality = 'Quality',
}

export enum InterviewCreativity {
  Deterministic = 'Deterministic',
  Creative = 'Creative',
}

export enum InterviewAnswerMode {
  Concise = 'Concise',
  Detailed = 'Detailed',
}
